import { render, staticRenderFns } from "./Alpari.vue?vue&type=template&id=56326546&lang=pug&"
import script from "./Alpari.vue?vue&type=script&lang=js&"
export * from "./Alpari.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports